import React, {useEffect, useState} from 'react';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import {kbUserDataLoaded} from "../utils";
import {UserAvatar} from "../User/UserAvatar";
import {chatMessageRemoveReaction, chatMessageAddReaction} from "../API/chatAPI";
import {trackDeletedReaction} from "./utils";

export const MessageReactions = ({ reactions, message, setMessages, chatId }) => {
    // return <em-emoji id={'apple'} size="1.1em"></em-emoji>;
    if (!reactions) return null;

    const userId = kbUserDataLoaded?.myUserId;

    const handleClickMessageReaction = (emojiId) => {
        const myUserId = kbUserDataLoaded?.myUserId;
        const exists = !!message?.reactions?.[emojiId]?.[myUserId];

        if (exists) {
            chatMessageRemoveReaction(chatId, message?.msgId, emojiId).then();
            setMessages(prevMessages => prevMessages.map(msg => {
                if (msg.msgId === message.msgId) {
                    const updatedReactions = { ...msg.reactions };
                    if (updatedReactions[emojiId] && updatedReactions[emojiId][userId]) {
                        delete updatedReactions[emojiId][userId];
                        if (Object.keys(updatedReactions[emojiId]).length === 0) {
                            delete updatedReactions[emojiId]; // Remove the emoji key if no users left
                        }
                    }
                    return { ...msg, reactions: updatedReactions };
                }
                return msg;
            }));
        } else {
            chatMessageAddReaction(chatId, message?.msgId, emojiId);
            setMessages(prevMessages => prevMessages.map(msg => {
                if (msg.msgId === message?.msgId) {
                    const reactions = msg.reactions || {};
                    const emojiReactions = reactions[emojiId] || {};
                    emojiReactions[userId] = true;
                    return { ...msg, reactions: { ...reactions, [emojiId]: emojiReactions } };
                }
                return msg;
            }));
        }
    };

    const sortedReactions = Object.entries(reactions).sort((a, b) => {
        // const countA = Object.keys(a[1]).length;
        // const countB = Object.keys(b[1]).length;
        // if (countA !== countB) {
        //     return countB - countA;
        // }
        return a[0].localeCompare(b[0]);
    });

    const reactionElements = sortedReactions.map(([emojiId, users]) => {
        const userCount = Object.keys(users).length;
        const userList = Object.keys(users).map(userId => {
            return <UserAvatar key={userId} alt="User" msgUserId={userId} style={{width: 24, height: 24, marginRight: 4}}/>
        });

        return (
            <Tooltip key={emojiId}
                     title={<Box sx={{ display: 'flex', flexDirection: 'column' }}>
                         <Box component="span" sx={{ fontWeight: 'bold', padding: '6px 0px 6px' }}>Reacted By:</Box>
                         <Box sx={{ display: 'flex' }}>{userList}</Box>
                     </Box>}
                     placement="top" arrow>
                <Box component="span" sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    m: 0.5,
                    cursor: 'pointer',
                    zIndex: 100
                }}
                     onClick={() => handleClickMessageReaction(emojiId)}>
                    <em-emoji id={emojiId} size="1.1em"></em-emoji>
                    <Box component="span" sx={{ ml: 0.5 }}>{userCount}</Box>
                </Box>
            </Tooltip>
        );
    });

    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
            {reactionElements}
        </Box>
    );
};
